export const BACKBONE_APP_ROOT = 'bb-app-root';

